export const paymentKeys = {
  // Vendor payment settings
  merchantAll: ["merchant-payments"] as const,
  merchantList: () => [...paymentKeys.merchantAll, "list"] as const,
  // System admin payment providers
  systemAll: ["system-payments"] as const,
  systemLists: () => [...paymentKeys.systemAll, "list"] as const,
  systemList: (params?: Record<string, unknown>) =>
    [...paymentKeys.systemLists(), params] as const,
  // Stripe status
  stripeStatus: (paymentId: string) =>
    ["payment", "stripe", "status", paymentId] as const,
};
